import Vue from "vue";
import Router from "vue-router";
import Page from "./views/Page.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:jobIndex/:jobCategory/:job/apply",
      name: "job-application",
      component: Page,
      meta: {
        jobApplication: true
      }
    },
    {
      path: "/:jobIndex/:jobCategory/:job/complete",
      name: "job-complete",
      component: Page,
      meta: {
        jobApplication: true
      }
    },
    {
      path: "/*",
      name: "pages",
      component: Page
    }
  ],
  
//   scrollBehavior() {
//   if (to.hash) {
//     const element = document.querySelector(to.hash);
//     if (element) {
//       setTimeout(() => {
//         window.scrollTo({
//         top: element.offsetTop,
//         //behavior: 'smooth'
//       });
//     }, 100);
     
//     }
//   }
//    setTimeout(() => {
//         window.scrollTo({ top: 0 });
//     }, 300);
 
// }

 
//   scrollBehavior (to, from, savedPosition) {
//      setTimeout(() => {
//         return { x: 0, y: 0 };
//     }, 300);
  
// }

scrollBehavior(to: any, from: any, savedPosition: any) {
  return new Promise((resolve: any, reject: any) => {
    setTimeout(() => {
      resolve({ x: 0, y: 0 });
    }, 500);
  });
}
});
